/** Local-date <-> ISO (YYYY-MM-DD) helpers for the availability calendar.
 * Deliberately avoids `toISOString()` (UTC) so a clicked calendar day never
 * shifts by a day for users west of UTC. */
export const parseIsoDate = (iso) => {
  if (!iso) return null;
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
};

export const formatIsoDate = (date) => {
  if (!date) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};
